<template>
  <v-card class="d-flex pa-2 flex-column" outlined>
    <v-alert
      v-model="flashError"
      dense
      border="left"
      type="error"
      dismissible
      elevation="2"
    >
      {{ flashErrorMessage }}
    </v-alert>

    <merchant-transaction-filter
      :search="search"
      v-on:clearSearchParent="clearSearch"
      v-on:getDataParent="getData"
      :loading="loading"
    />

    <TableView
      :headers="headers"
      :items="allData"
      :options.sync="options"
      :loading="loading"
      :totalData="totalData"
      :customTopActions="true"
      item-key="id"
      table-height="70vh"
      @select-row="selectRow"
    >
      <template v-slot:top>
          <table-top-vue
            :loading="loading"
            :listButton="listButton"
            v-on:getDataParent="getData"
            v-on:exportItemParent="exportItem"
            v-on:exportExcelParent="exportExcel"
            :switchCh="switchCh"
            v-on:onSwitch="handleSwitch"
          />
        </template>
        <template slot="action" slot-scope="{ item }">
        <div class="d-flex justify-center align-center" style="height: 100%">
          <v-icon
            @click="viewItem(item.id)"
            size="20"
          >
            mdi-eye
          </v-icon>
        </div>
      </template>
    </TableView>

    <v-dialog v-model="dialog" max-width="500px">
      <table-detail :editedItem="editedItem" v-on:closeParent="close" />
    </v-dialog>
  </v-card>
</template>

<script>
import { getDate, date, showAlert } from '../../lib/helpers';
import { headers, search, editedItem } from '../../components/report/cpts-transaction/attributes';

export default {
  components: {
    TableView: () => import("../../components/@drontVue/components/Table/TableView.vue"),
    TableDetail: () =>
      import('../../components/table/CptsTransactionDetail.vue'),
    TableTopVue: () => import('../../components/table/TableTop.vue'),
    MerchantTransactionFilter: () =>
      import('../../components/table/CptsTransactionFilter.vue'),
  },
  data: () => ({
    listButton: {
      buttonRestart: true,
      buttonDots: true,
      buttonDotsExt: [
        {
          link: 'exportItemParent',
          show: true,
          icon: 'mdi-file-excel',
          title: 'Export to excel',
          voidStatus: true,
        },
      ],
    },
    isFirstLoad: true,
    options: {},
    view: false,
    show: false,
    dialog: false,
    headers,
    search,
    editedItem,
    selectedRow: '',
    editedIndex: -1,
  }),

  computed: {
    allData() {
      return this.$store.state.report.cptsTransaction.allData;
    },
    detailData() {
      return this.$store.state.report.cptsTransaction.item;
    },
    totalData() {
      return this.$store.state.report.cptsTransaction.totalData;
    },
    totalPage() {
      return this.$store.state.report.cptsTransaction.totalPage;
    },
    loading() {
      return this.$store.state.report.cptsTransaction.loading;
    },
    flashError: {
      get() {
        return this.$store.state.report.cptsTransaction.flashError;
      },
      set() {
        this.$store.commit('report/cptsTransaction/setFlashErrorMessage', '');
      },
    },
    flashErrorMessage() {
      return this.$store.state.report.cptsTransaction.flashErrorMessage;
    },
  },

  watch: {
    options: {
      handler() {
        if (!this.isFirstLoad) {
          this.getData();
        } else {
          this.$store.commit('report/cptsTransaction/clearData');
        }
        this.isFirstLoad = false;
      },
      deep: true,
    },
  },

  methods: {
    selectRow(index) {
      if (this.selectedRow !== index) {
        this.selectedRow = index;
      } else {
        this.selectedRow = '';
      }
    },

    rowClass() {
      const rowClass = 'max-width-col';
      return rowClass;
    },

    getData() {
      if (this.search.trx_datetime.length < 1) {
        this.$vuetify.goTo(0);
        showAlert(
          this.$store,
          'transaction date is required !',
          'mdi-alert',
          'red'
        );
        this.$store.commit('report/cptsTransaction/clearData');
      } else {
        this.$store.commit('report/cptsTransaction/setFlashErrorMessage', '');
        const { page, itemsPerPage } = this.options;
        this.$store
          .dispatch('report/cptsTransaction/getData', {
            date,
            page,
            itemsPerPage,
            search: this.search,
          })
          .then(() => {
            if (this.totalPage < page) {
              if (this.totalPage === 0) {
                this.options.page = 1;
              } else {
                this.options.page = this.totalPage;
              }
            }
          });
      }
    },

    async viewItem(itemId) {
      await this.$store
        .dispatch('report/cptsTransaction/getDetail', {
          id: itemId,
          date,
        })
        .then(() => {
          if (!this.loading && this.detailData != null) {
            this.editedIndex = itemId;
          }
          this.editedItem = { ...this.detailData };
          this.view = true;
          this.editedIndex = -2;
          this.dialog = true;
        });
    },
    close() {
      this.view = false;
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = { ...this.defaultItem };
        this.editedIndex = -1;
      });
    },

    closeFlash() {
      this.$store.commit('report/cptsTransaction/setFlashErrorMessage', '');
    },

    clearSearch() {
      this.search.trx_datetime = [];
      this.search.payment_type = '';
      this.search.rrn = '';
      this.search.mid = '';
      this.search.status = '';
      this.search.trx_pan = '';
      this.search.invoice_number = '';

      this.$nextTick(() => {
        this.$store.commit('report/cptsTransaction/clearData');
        this.$store.commit('report/clearMerchant');
      });
    },

    getDate,

    exportItem() {
      if (this.totalData < 1) {
        this.$vuetify.goTo(0);
        showAlert(this.$store, 'Data is empty !', 'mdi-alert', 'red');
        this.$store.commit('report/cptsTransaction/clearData');
      } else {
        const { page, itemsPerPage, sortBy, sortDesc } = this.options;

        this.$store.dispatch('exportList', {
          date,
          page,
          itemsPerPage,
          sortBy,
          sortDesc,
          search: this.search,
          exportUrl: 'api/v1/export/export-cpts-transaction/index',
          exportController: 'export-cpts-transaction',
        });
      }
    },
  },
};
</script>

<style>
.max-width-col td {
  white-space: nowrap;
  overflow: hidden;
  max-width: 250px;
  text-overflow: ellipsis;
}
.v-data-table .v-data-table__wrapper {
  height: 100%;
}
</style>
